import { CreateCourseSubjectType } from "../../../types/CourseSubject";
import { post } from "../../../utils/axios-config";
import { COURSES_SUBJECTS } from "../../../utils/constants";

export const createCourseSubject = async (data: CreateCourseSubjectType) => await post<CreateCourseSubjectType, string>(COURSES_SUBJECTS, data);